import React, { useState, useEffect } from 'react';

function Highlights(){
    const [highlight, setHighlight] = useState(null)
    
    return (
        <div>
           <p>This is the page for highlights</p>
        </div>
    )
}
export default Highlights